<template>
  <div class="leftmeau">
    <div class="leftLayout" @click="closeMeau" :style="{ height: objData ? 'none':'100%' }">
      <img :src="$appLogo" class="logo" alt="图标">
      <div class="meau">
        <div v-for="(item,index) in navList" :key="index" class="nav" :title="item.name"
          @mouseover.stop="mouseover(item)" @mouseleave.stop="mouseleave(item)"
        >
          <img v-if="!item.isHover" :src="item.icon" alt="标题">
          <img v-else :src="item.icons" alt="标题">
        </div>
      </div>
    </div>
    <div v-if="meauArea" class="leftArea">
      <span v-for="(item,index) in navList" :key="index" :class="{'active':item.isActive||item.isHover}"
        :title="item.name" @click="openMeau(item)" @mouseover="mouseover(item)" @mouseleave="mouseleave(item)"
      >{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    objData: {
      type: Object,
      required: false
    }, 
  },
  data() {
    return {
      navList: [
        { name: '模型树', icon: require("./../images/模型树.png"),
          icons: require("./../images/模型树s.png"), isActive: false, isHover: false },
        { name: '模型图纸', icon: require("./../images/模型图纸.png"),
          icons: require("./../images/模型图纸s.png"), isActive: false, isHover: false },
        { name: '空间', icon: require("./../images/空间树.png"),
          icons: require("./../images/空间树s.png"), isActive: false, isHover: false },
        { name: '系统', icon: require("./../images/系统树.png"),
          icons: require("./../images/系统树s.png"), isActive: false, isHover: false },
        { name: '属性', icon: require("./../images/属性.png"),
          icons: require("./../images/属性s.png"), isActive: false, isHover: false },
        { name: '选择集', icon: require("./../images/选择集.png"),
          icons: require("./../images/选择集s.png"), isActive: false, isHover: false }
      ],
      meauArea: false
    }
  },
  methods: {
    mouseover(item) {
      this.navList.forEach(ele => {
        if (item.name === ele.name) {
          ele.isHover = true
        } else {
          ele.isHover = false
        }
      })
      item.isHover = true;
      this.meauArea = true;
    },
    mouseleave(item) {
      item.isHover = false
    },
    openMeau(item) {
      // this.navList.forEach(ele=>{
      //   if(item.name == ele.name){
      //     ele.isActive = true
      //   }else{
      //     ele.isActive=false
      //   }
      // })
      this.meauArea = false;
      this.$parent.$refs.modelDwglist.closeArea()
      this.$parent.$refs.modelattr.closeArea()
      this.$parent.$refs.modeltree.closeArea()
      this.$parent.$refs.spaceTree.closeArea()
      this.$parent.$refs.systemTree.closeArea()
      this.$parent.$refs.selectSet.closeArea()
      if (item.name === '模型树') {
        this.$parent.$refs.modeltree.openArea()
      } else if (item.name === '模型图纸') {
        this.$parent.$refs.modelDwglist.openArea()
      } else if (item.name === '属性') {
        this.$parent.$refs.modelattr.openArea()
      } else if (item.name === '空间') {
        this.$parent.$refs.spaceTree.openArea()
      } else if (item.name === '系统') {
        this.$parent.$refs.systemTree.openArea()
      }else if (item.name === '选择集') {
        this.$parent.$refs.selectSet.openArea()
      }
    },
    closeMeau() {
      this.meauArea = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.leftLayout{
  position: absolute;
  left: 0;
  top: 0;
  width: 56px;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  .logo{
    margin-top: 12px;
    margin-bottom: 15px;
    height: 37px;
  }
  .meau{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .nav{
    width: 100%;
    height: 34px;
    margin: 5px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // cursor: pointer;
    img{
      cursor: pointer;
      // width: 100%;
      // height: 100%;
    }
  }
}
.leftArea{
  position: absolute;
  width: 85px;
  left: 56px;
  top: 64px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 0px 6px 6px 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  span{
    width: 100%;
    height: 34px;
    margin: 5px 0;
    text-align: center;
    line-height: 34px;
    cursor: pointer;
    display: inline-block;
  }
  // span:hover{
  //   background-color: rgba(56, 115, 254, 0.18);
  // }
  .active{
    background-color: rgba(56, 115, 254, 0.18);
    color: #3873FE;
  }
}
</style>
